import { GoogleOAuthProvider } from '@react-oauth/google'
import { AlertProvider } from 'contexts/alert'
import { ApplicationProvider } from 'contexts/application'
import { AuthProvider } from 'contexts/auth'
import { CustomThemeProvider } from 'contexts/theme'
import React, { PropsWithChildren } from 'react'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthenticationsProvider } from 'contexts/authentications'
import { CofreDigitalsProvider } from 'contexts/cofre-digital'
import { CollaboratorssProvider } from 'contexts/collaborators'
import { SidebarProvider } from 'contexts/sidebar'
import { StoresProvider } from 'contexts/store'

const composeProviders = (providers: React.FC<PropsWithChildren>[]) => {
  return providers.reduce((Acc, Provider) => {
    return (props) => (
      <Provider>
        <Acc {...props} />
      </Provider>
    )
  })
}

const ContextProviders = composeProviders([
  AlertProvider,
  ApplicationProvider,
  CofreDigitalsProvider,
  AuthenticationsProvider,
  StoresProvider,
  CollaboratorssProvider,
])

const AppProvider = ({ children }: PropsWithChildren) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: 1,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
      },
    },
  })

  return (
    <GoogleOAuthProvider clientId={import.meta.env.VITE_APP_GOOGLE_CLIENT_ID}>
      <QueryClientProvider client={queryClient}>
        <CustomThemeProvider>
          <AuthProvider>
            <ContextProviders>
              <SidebarProvider>{children} </SidebarProvider>
            </ContextProviders>
          </AuthProvider>
        </CustomThemeProvider>
      </QueryClientProvider>
    </GoogleOAuthProvider>
  )
}

export default AppProvider
